import { Slide } from "packages/lesson/dist/@types";
import { task as task02 } from "../../../../../task/course-03/lesson-10/task-02";

const task: Slide = {
  title: `What are the properties of the radiosity method?`,
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
